import React, { Component } from "react";
import { Div } from "atomize";

import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";

import {
  Player,
  ControlBar,
  CurrentTimeDisplay,
  TimeDivider,
  VolumeMenuButton,
} from "video-react";

const buzzVideoParams = {
  // fluid: false,
  playsInline: true,
  autoPlay: false,
  isFullscreen: true,
};

export default class EngagementVideo extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div m={{t: "4.44rem"}}>
            <Player
              {...buzzVideoParams}
              className="video-modal"
              poster="../images/pricing-video.png"
            >
              <source src={content.video} />
              <ControlBar>
                <CurrentTimeDisplay order={4.1} />
                <TimeDivider order={4.2} />
                <VolumeMenuButton order={8} />
              </ControlBar>
            </Player>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
